import React from 'react';

export function Skills(){
    return(
        <div></div>
    )
}

export default Skills;